import { useEffect, useState } from "react";
import { db } from "../Firebase";
import AdminNavbar from "./AdminNavbar";
import { MdDelete } from "react-icons/md";

export default function Program() {

    function submitPrograms(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        var icon = data.get("icon");
        var img = data.get("img");
        var name = data.get("name");
        var desc = data.get("desc");
        var duration = data.get("duration");
        var features = data.get("features");

        db.collection("programs").add({
            icon: icon,
            img: img,
            name: name,
            desc: desc,
            duration: duration,
            features: features,
        }).then((succ) => {
            alert("Program Added");
            e.target.reset();
            e.target.icon.focus();
        })
    }

    const [pro, setpro] = useState([]);

    function fetchprograms() {
        db.collection("programs").onSnapshot((succ) => {
            setpro(succ.docs);
        })
    }

    useEffect(() => {
        fetchprograms()
    }, [])

    return (
        <>
            <div className="bg-light min-vh-100">
                <AdminNavbar />
                <div className="container-fluid px-4 py-1">
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
                        <div>
                            <h4 className="mb-0">Program Management</h4>
                            <p className="text-muted">
                                {pro.length} Program
                            </p>
                        </div>
                        <button data-bs-toggle="modal" data-bs-target="#modal" className="btn btn-dark px-4 mb-2">
                            + Add Progarms
                        </button>
                    </div>
                    <div className="card shadow-sm ps-1">
                        <div className="card-body p-0">
                            <div className="table-responsive" >
                                <table className="table table-hover align-middle mb-0 text-nowrap">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Duration</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pro.map((row, index) => (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <img src={row.data().img} className="img-fluid rounded-circle" style={{ width: 50, height: 50 }} />
                                                </td>
                                                <td>{row.data().icon} {row.data().name}</td>
                                                <td>{row.data().desc.slice(0, 20) + "..."}</td>
                                                <td>{row.data().duration}</td>
                                                <td>
                                                    <button className="btn btn-danger btn-sm"><MdDelete /></button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="modal" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Add Programs</h5>
                            <button className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={submitPrograms}>
                                <label className="form-label small text-dark">Add Icon</label>
                                <input required type="text" placeholder="like 🥽.." name="icon" className="form-control mb-1" />
                                <label className="form-label small text-dark">Add Image</label>
                                <input required type="url" placeholder="like https://..." name="img" className="form-control mb-1" />
                                <label className="form-label small text-dark">Add Program Name</label>
                                <input required type="text" placeholder="like Fat Loss Program.." name="name" className="form-control mb-1" />
                                <label className="form-label small text-dark">Add Description</label>
                                <input required type="text" placeholder="Add Description.." name="desc" className="form-control mb-1" />
                                <label className="form-label small text-dark">Add Features</label>
                                <textarea rows={3} required type="text" placeholder="Add Features.." name="desc" className="form-control mb-1" />
                                <label className="form-label small text-dark">Add Duration</label>
                                <input required type="text" placeholder="like 8 weeks.." name="duration" className="form-control mb-1" />
                                <button type="submit" className="btn btn-danger">Add Program</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}